import React from 'react';
import { Modal, Button } from 'antd';
import { Flame, X } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';

const StreakInfoModal = ({ isOpen, onClose, streak = 0, streakIconUrl = null }) => {
  const { mode } = useTheme();
  const isDark = mode === 'dark';

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={480}
      centered
      className="streak-info-modal"
      styles={{
        content: {
          padding: 0,
          borderRadius: '16px',
          fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        }
      }}
    >
      <div className={`${isDark ? 'bg-white/5' : 'bg-white'} rounded-2xl overflow-hidden`} style={{ fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
        {/* Header */}
        <div className={`px-6 py-5 border-b ${isDark ? 'border-white/10' : 'border-slate-100'} flex items-start justify-between`}>
          <div className="flex items-start gap-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center overflow-hidden border ${isDark ? 'bg-orange-500/20 border-orange-500/30' : 'bg-orange-50 border-orange-100'}`}>
              {streakIconUrl ? (
                <img src={streakIconUrl} alt="Streak Badge" className="w-full h-full object-cover" />
              ) : (
                <Flame size={24} className={isDark ? 'text-orange-400' : 'text-orange-500'} fill={isDark ? 'rgba(251, 146, 60, 0.3)' : 'currentColor'} />
              )}
            </div>
            <div className="flex flex-col">
              <h2 className={`text-lg font-black ${isDark ? 'text-white' : 'text-slate-900'} mb-1`}>
                Monthly Streak
              </h2>
              <span className={`text-[10px] font-black uppercase tracking-widest ${isDark ? 'text-white/60' : 'text-slate-400'
                }`}>
                CONSECUTIVE MONTHS
              </span>
            </div>
          </div>
          <Button
            type="text"
            icon={<X size={16} />}
            onClick={onClose}
            className={`${isDark ? 'text-white/60 hover:text-white hover:bg-white/10' : 'text-slate-400 hover:text-slate-600 hover:bg-slate-100'} !rounded-full`}
          />
        </div>

        {/* Current Streak Status */}
        <div className="px-6 pt-5">
          <div className={`p-4 rounded-xl border flex items-center justify-between ${isDark ? 'bg-orange-500/5 border-orange-500/10' : 'bg-orange-50/50 border-orange-100/50'
            }`}>
            <div className="flex flex-col">
              <span className={`text-[9px] font-black uppercase tracking-widest ${isDark ? 'text-white/40' : 'text-slate-400'} mb-1`}>
                Your Progress
              </span>
              <span className={`text-xl font-black ${isDark ? 'text-white' : 'text-slate-900'}`}>
                {streak} {streak === 1 ? 'Month' : 'Months'}
              </span>
            </div>
            <div className={`px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest ${streak > 0
                ? (isDark ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-600')
                : (isDark ? 'bg-white/5 text-white/40' : 'bg-slate-100 text-slate-400')
              }`}>
              {streak > 0 ? 'Active' : 'No Streak'}
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="px-6 py-5">
          <p className={`text-sm leading-relaxed ${isDark ? 'text-white/80' : 'text-slate-700'}`}>
            Your streak counts how many months in a row you've submitted goals on time. Keep it going to earn recognition and stay on track.
          </p>
        </div>

        {/* Reward Box */}
        <div className={`px-6 pb-6 ${isDark ? 'border-t border-white/10 pt-5' : 'border-t border-slate-100 pt-5'}`}>
          <div className={`p-4 rounded-xl border ${isDark
              ? 'bg-white/5 border-white/10'
              : 'bg-slate-50 border-slate-100'
            }`}>
            <p className={`text-sm ${isDark ? 'text-white/80' : 'text-slate-700'}`}>
              Submit goals on time and maintain streak. Every month you get 1 streak point.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default StreakInfoModal;
